var audio_rtlignore_default = {
  "fontElementMap": "FdnBu",
  "container": "-oWpY",
  "customPlayer": "_82dn1",
  "slim": "fntzX",
  "playPauseButton": "m42hD",
  "coverImage": "epidy",
  "trackDetailsContainer": "qFnYp",
  "controlsContainer": "_3YGuv",
  "controlsGroup": "_4chja",
  "sliderContainer": "kQpvN",
  "audioDuration": "-wi4s",
  "isLoading": "dSTbp",
  "audioIconButton": "hpBzj",
  "audioVolumeWrapper": "iIQ-x",
  "volumeSliderWrapper": "_5aL-l",
  "audioDetails": "HKUGS",
  "authorName": "PXF7G",
  "title": "iv4TL",
  "audioContextMenuWrapper": "loPjF",
  "dropdownMenuWrapper": "wZk1r",
  "dropdownSelectedButton": "Q5SLx",
  "dropdownContent": "_5iR3U",
  "dropdownContentWithIcon": "RrCzX",
  "audioLoader": "UhJLQ"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
